// M-13 P11-20 premium (simplified v1 — no BFR/VFR/NS/CC / multi-commodity).
// Inputs from loadMcoAreaBundle only.

const round = (v, digits = 0) => {
  const p = 10 ** digits;
  return Math.round((Number(v) + Number.EPSILON) * p) / p;
};

/**
 * @param {object} bundle — from loadMcoAreaBundle
 */
export function computeMcoProducerPremium(bundle) {
  if (!bundle) return { ready: false, blockers: ["ADM bundle missing"], result: null };

  const {
    projectedPrice,
    approvedYield,
    acres,
    coverageRange,
    protectionFactor,
    insuredShareDecimal,
    baseRate,
    subsidyPercent,
    multiplicativeOptionalRateAdj = 1,
  } = bundle;

  const expectedCommodityValue = round(projectedPrice * approvedYield * acres, 0);
  const totalGuaranteeAmount = round(expectedCommodityValue * coverageRange, 0);
  let liabilityAmount = round(totalGuaranteeAmount * protectionFactor * insuredShareDecimal, 0);
  if (liabilityAmount < 1) liabilityAmount = 1;

  const preliminaryTotalPremium = liabilityAmount * baseRate * multiplicativeOptionalRateAdj;
  const totalPremiumAmount = round(preliminaryTotalPremium, 0);
  const subsidyAmount = round(totalPremiumAmount * subsidyPercent, 0);
  const producerPremiumAmount = totalPremiumAmount - subsidyAmount;

  return {
    ready: true,
    blockers: [],
    result: {
      expectedCommodityValue,
      totalGuaranteeAmount,
      liabilityAmount,
      totalPremiumAmount,
      subsidyAmount,
      producerPremiumAmount,
      baseRate,
      subsidyPercent,
      coverageRange,
      label: "ADM + M-13",
    },
  };
}
